// src/utils/api/boatValidators.ts
//Semi-locked

import { Validator, createObjectValidator, createArrayValidator, isNumber, isString, isObject } from './validation';

// Define the Boat type for reuse
type Boat = {
    BoatId: number;
    BoatModel: string;
    Boat_UrlId?: string;  // SEO-friendly URL identifier (optional for backward compatibility)
    I: number;
    J: number;
    P: number;
    E: number;
};

// Define the PaginatedResponse type
type PaginatedBoatResponse = {
    boats: Boat[];
    totalCount: number;
    currentPage: number;
    totalPages: number;
};

// Response shape validators
const isPaginatedResponse = createObjectValidator<PaginatedBoatResponse>({
    boats: (value: unknown): value is Boat[] =>
        Array.isArray(value) && value.every(boat => isBoat(boat)),
    totalCount: isNumber,
    currentPage: isNumber,
    totalPages: isNumber
});

export const isBoat = createObjectValidator<Boat>({
    BoatId: isNumber,
    BoatModel: isString,
    Boat_UrlId: (v): v is string | undefined => v === undefined || isString(v),  // Optional SEO-friendly URL
    I: isNumber,
    J: isNumber,
    P: isNumber,
    E: isNumber
});

// Create validators
export const boatListValidator = new Validator<PaginatedBoatResponse>([
    {
        validate: isPaginatedResponse,
        message: 'Invalid response format'
    }
]);